import { Input as InputCore } from 'antd';
import cx from 'classnames';

import styles from './Input.module.scss';
import InputLabel from '../inputLabel/InputLabel';
import InputHelperText from '../inputHelperText/InputHelperText';
import { TInputProps, TTextAreaProps } from './Input.type';

const { TextArea, Password } = InputCore;

export default function Input(props: TTextAreaProps | TInputProps) {
	const {
		id,
		required,
		className,
		helperText,
		label = null,
		error,
		errorText = null,
		classes = {},
		inputRef,
		type = 'text',
		placeholder,
	} = props;

	const _renderInputCore = () => {
		if (type === 'textarea') {
			return (
				<TextArea
					{...(props as TTextAreaProps)}
					ref={inputRef}
					className={cx(classes.input, {
						[styles.error]: error,
					})}
				/>
			);
		} else if (type === 'password') {
			return (
				<Password
					{...(props as TInputProps)}
					ref={inputRef as TInputProps['inputRef']}
					className={cx(classes.input, {
						[styles.error]: error,
					})}
				/>
			);
		}

		return (
			<InputCore
				{...(props as TInputProps)}
				ref={inputRef as TInputProps['inputRef']}
				className={cx(classes.input, styles.input, {
					[styles.error]: error,
				})}
			/>
		);
	};

	return (
		<div className={className}>
			{label ? (
				<InputLabel htmlFor={id} required={required} className={classes.label}>
					{label}
				</InputLabel>
			) : null}
			{_renderInputCore()}
			{helperText || errorText ? (
				<InputHelperText className={classes.helperText} error={!!errorText}>
					{error && errorText ? errorText : helperText}
				</InputHelperText>
			) : null}
		</div>
	);
}
